import { Card } from "components/common";
import styled from "styled-components";

export const StyledLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 700px;
  height: 20vh;
  min-height: 400px;
`;

export const StyledFormHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

export const StyledForm = styled.form`
  width: 500px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

export const StyledFormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 4rem;

  > span {
    flex: 1;
  }
`;

export const StyledFormFooter = styled.div`
  margin-top: auto;
`;

export const StyledAnchor = styled.a`
  text-decoration: underline;
  color: blue;
  cursor: pointer;
`;
